<script lang="ts">
	import { getContext, onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import IconButton from '../../buttons/IconButton.svelte';
	import DropdownPositionPatch from '../../dropdown/DropdownPositionPatch.svelte';
	import {
		FilterCondition,
		buildFilterValue,
		type FilterOption,
		type OptionFilterValue,
		type SimpleListContext
	} from '../../../types/ListTypes';

	const { updateFilterActivityState } = getContext<SimpleListContext>('enzianListContext');

	let value: number | undefined = $state();
	let data: OptionFilterValue[] = $state([]);

	interface Props {
		filterCondition?: FilterCondition;
		filterOption: FilterOption;
	}

	let { filterCondition = FilterCondition.EQ, filterOption = $bindable() }: Props = $props();

	function handleFilterChange() {
		if (value != undefined) {
			filterOption.value = buildFilterValue(value, filterCondition);
			updateFilterActivityState();
		} else {
			filterOption.value = null;
			updateFilterActivityState();
		}
	}

	function handleOptionSelected(item: OptionFilterValue) {
		value = item ? item.value : undefined;
		handleFilterChange();
	}

	function parseString(rawString: string | null): number | null {
		//Read value back in.
		if (rawString != null && rawString != 'null') {
			const values = rawString.split('|');
			return values.length >= 2 ? parseInt(values[0]) || null : null;
		} else {
			return null;
		}
	}

	onMount(() => {
		if (filterOption.optionsOption?.options) {
			data = filterOption.optionsOption.options;
		} else if (filterOption.optionsOption?.loadOption) {
			//Set the data
			filterOption.optionsOption.loadOption.then((options) => {
				data = options;
			});
		}
	});
</script>

<div class="flex gap-2 items-center">
	<div class="grow">
		<DropdownPositionPatch
			hint={filterOption.optionsOption?.hint}
			patchPropertyName=""
			selectionPropertyName="id"
			options={data}
			selected={data.find((opt) => opt.value == parseString(filterOption.value))}
			displayPropertyName={'displayValue'}
			onOptionSelected={handleOptionSelected}
		/>
	</div>

	<IconButton
		size="small"
		hoverText={$_('general.lbl_delete')}
		onClick={() => {
			//Set the value to null
			value = undefined;
			handleFilterChange();
		}}
		iconName="eraser"
	/>
</div>
